import { useEffect, useState } from 'react';

/**
 * Measures the vertical space left below a ref'd element (down to the bottom of the
 * viewport, minus some breathing room) and keeps it in sync as the window resizes or
 * any of the given deps change (e.g. a filter panel collapsing/expanding above it).
 *
 * Returns a pixel height to apply via inline style/CSS variable — Leaflet needs an
 * actual measured height on its container, a CSS "flex: 1" alone won't size the map.
 */
const useFillRemainingHeight = (ref, { minHeight = 400, bottomPadding = 20, deps = [] } = {}) => {
  const [height, setHeight] = useState(minHeight);

  useEffect(() => {
    const measure = () => {
      if (!ref.current) {
        return;
      }
      const top = ref.current.getBoundingClientRect().top;
      const available = window.innerHeight - top - bottomPadding;
      setHeight(Math.max(available, minHeight));
    };

    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, minHeight, bottomPadding, ...deps]);

  return height;
};

export default useFillRemainingHeight;
